module.exports = __webpack_public_path__ + "img/bg@2x.776cf6f.png";